<head>
    <meta name="viewport" contetent="width=device-width, intial scale=1.0" />
</head>
<error-summary></error-summary>
<div class="centered-content container-fluid">
    <div class="col-md-12">        
        <div [innerHtml]="privacyPolicySitecoreTemplate.PrivacyPolicyText"></div>
    </div>
</div>
